import React from "react";
import { testimonials } from "../Data";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";
import "swiper/css";

const headingVariant = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: .8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const contentVariant = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: .5,
    },
  },
};

const Testimonials = () => {
  return (
    <section className="testimonial-section">

      <div className="container">

        <motion.h2
          className="section-heading"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
            Loved by  <span>Fast Growing Teams
          </span>
        </motion.h2>

        <motion.p
          className="section-text testimonial-top-text"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ delay: .15 }}
        >
          Automate your WhatsApp marketing in three easy steps to instantly
          connect with target users, drive engagement and boost sales.
        </motion.p>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={24}
          slidesPerView={3}
          loop
          speed={1200}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>

              <motion.div
                className="testimonial-card"
                whileHover={{
                  y: -8,
                  scale: 1.02,
                }}
                transition={{
                  type: "spring",
                  stiffness: 260,
                  damping: 20,
                }}
              >

                <motion.div
                  className="testimonial-stars"
                  variants={contentVariant}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  {[...Array(item.stars)].map((_, i) => (
                    <motion.div
                      key={i}
                      initial={{
                        scale: 0,
                        rotate: -90,
                      }}
                      whileInView={{
                        scale: 1,
                        rotate: 0,
                      }}
                      viewport={{ once: true }}
                      transition={{
                        delay: i * .08,
                        type: "spring",
                        stiffness: 280,
                      }}
                      style={{ display: "inline-flex" }}
                    >
                      <FaStar />
                    </motion.div>
                  ))}
                </motion.div>

                <motion.p
                  className="testimonial-review section-text"
                  variants={contentVariant}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  transition={{ delay: .2 }}
                >
                  "{item.review}"
                </motion.p>

                <motion.div
                  className="testimonial-stat"
                  variants={contentVariant}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  transition={{ delay: .3 }}
                >
                  <h3 className="card-heading">{item.stat}</h3>
                  <span className="section-text">
                    {item.statText}
                  </span>
                </motion.div>

                <motion.div
                  className="testimonial-user"
                  variants={contentVariant}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  transition={{ delay: .4 }}
                >

                  <motion.div
                    className="user-icon"
                    whileHover={{
                      scale: 1.1,
                    }}
                  >
                   <img src={item.img} alt={`${item.name} | ONBBITS`}></img>
                  </motion.div>

                  <div>
                    <h3 className="card-heading">
                      {item.name}
                    </h3>

                    <p className="section-text">
                      {item.designation}
                    </p>
                  </div>

                </motion.div>

              </motion.div>

            </SwiperSlide>
          ))}
        </Swiper>

      </div>

    </section>
  );
};

export default Testimonials;